import React from "react";
import { ShieldCheck, UserRound, Zap, Bitcoin } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import useReveal from "../../hooks/useReveal";

const ICONS = [ShieldCheck, UserRound, Zap, Bitcoin];

const Benefits = () => {
  const { t } = useLanguage();
  const ref = useReveal();

  return (
    <section
      id="benefits"
      ref={ref}
      data-testid="benefits-section"
      className="relative py-24 md:py-32 bg-black"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left pinned header */}
          <div className="lg:col-span-5 lg:sticky lg:top-32 h-fit">
            <p
              className="reveal font-mono-l text-[11px] text-[#e8d4a8] mb-5 flex items-center gap-3"
              data-testid="benefits-eyebrow"
            >
              <span className="w-6 h-px bg-[#e8d4a8]"></span>
              {t.benefits.eyebrow}
            </p>
            <h2
              className="reveal reveal-delay-1 font-display text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05]"
              data-testid="benefits-title"
            >
              {t.benefits.title}
            </h2>
            <div className="reveal reveal-delay-2 mt-10 w-24 h-24 dotted-divider"></div>
          </div>

          {/* Right list */}
          <div className="lg:col-span-7 space-y-0">
            {t.benefits.items.map((item, i) => {
              const Icon = ICONS[i] || ShieldCheck;
              return (
                <div
                  key={i}
                  className="reveal group relative grid grid-cols-[auto,1fr] gap-6 md:gap-10 py-10 border-t border-white/5 first:border-t-0 md:first:border-t md:first:border-white/5"
                  style={{ transitionDelay: `${i * 80}ms` }}
                  data-testid={`benefit-item-${i}`}
                >
                  <div className="flex flex-col items-start">
                    <span className="font-mono-l text-[10px] text-white/40">
                      0{i + 1}
                    </span>
                    <span className="mt-5 w-14 h-14 flex items-center justify-center border border-[#e8d4a8]/30 text-[#e8d4a8] group-hover:bg-[#e8d4a8] group-hover:text-black transition-all duration-500">
                      <Icon size={22} strokeWidth={1.25} />
                    </span>
                  </div>
                  <div>
                    <h3 className="font-display text-2xl md:text-[30px] text-white leading-snug mb-3">
                      {item.title}
                    </h3>
                    <p className="text-white/60 text-base leading-relaxed font-light max-w-xl">
                      {item.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
